export default __webpack_public_path__ + "static/lead-pc-3529a6b3a86d6d0fefdb659e3914a5ed.svg";